import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  Radio,
  OutlinedInput,
  Divider,
} from "@mui/material";
import { Icon } from "@iconify/react";

const dividerStyle = {
  py: 0,
  my: "2px !important",
  width: "80%",
  borderRadius: 2,
  border: "0.1px solid var(--app-border)",
};

const DropdownIcon = (props) => (
  <Icon
    icon="eva:arrow-ios-downward-fill"
    width={18}
    height={18}
    {...props}
  />
);

function SortByFilter({ value, onChange, component }) {
  return (
    <FormControl size="small">
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        IconComponent={DropdownIcon}
        input={<OutlinedInput />}
        displayEmpty
        renderValue={() => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            <span>Sort By:</span>

            {value && (
              <Box
                sx={{
                  ml:0,
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "var(--app-text)",
                }}
              >
                {value === "desc"
                  ? "Newest to Oldest"
                  : "Oldest to Newest"}
              </Box>
            )}
          </Box>
        )}
        sx={{
          height: 38,
          minWidth: 160,
          borderRadius: "10px",
          backgroundColor: component === "interpretations" || component === "referred-cases" || component === "centres" || component==="members" ? "var(--app-surface)" : "var(--app-surface)",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              borderRadius: "10px",
              border: component === "interpretations" || component === "referred-cases" || component === "centres" ? "1px solid var(--app-border)" : "1px solid var(--app-border)",
              boxShadow: "var(--app-shadow)",
            },
          },
          disableScrollLock: true,
        }}
      >
        <MenuItem
          value="desc"
          sx={{
            py: 0,
            "&.Mui-selected": { backgroundColor: "transparent" },
            "&.Mui-selected:hover": { backgroundColor: "transparent" },
          }}
        >
          <Radio
            checked={value === "desc"}
            size="small"
            sx={{
              color: "var(--app-border)",
              "&.Mui-checked": {
                color: "#5751E9",
              },
            }}
          />
          <ListItemText
            primary="Newest to Oldest"
            primaryTypographyProps={{
              fontSize: "14px",
              color: "var(--app-text)",
              fontWeight: 500,
            }}
          />
        </MenuItem>

        <Divider component="li" variant="middle" sx={dividerStyle} />

        {/* Oldest to Newest */}
        <MenuItem
          value="asc"
          sx={{
            py: 0,
            "&.Mui-selected": { backgroundColor: "transparent" },
            "&.Mui-selected:hover": { backgroundColor: "transparent" },
          }}
        >
          <Radio
            checked={value === "asc"}
            size="small"
            sx={{
              color: "var(--app-border)",
              "&.Mui-checked": {
                color: "#5751E9",
              },
            }}
          />
          <ListItemText
            primary="Oldest to Newest"
            primaryTypographyProps={{
              fontSize: "14px",
              color: "var(--app-text)",
              fontWeight: 500,
            }}
          />
        </MenuItem>
      </Select>
    </FormControl>
  );
}

export default SortByFilter;
